<template>
  <div class="container fluid">
    <div class="shape"></div>
    <div class="login row">
      <div class="login__popin col-xs-10 col-md-6">
        <Logo class="login__popin__logo" color />
        <p class="login__popin__subtext">
          Entrez votre adresse email pour accéder à votre espace
        </p>
        <form v-on:submit.prevent="submitForm">
          <div class="login__popin__input">
            <input
              v-model="mail"
              class="input"
              type="email"
              placeholder="nom@email.com"
              required
            />
            <div class="input__error">{{ error }}</div>
          </div>

          <Button class="login__popin__button" type="submit" secondary>
            Accéder à la bêta
          </Button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { emailValidate } from "@/plugins/helpers";
import { mapGetters, mapMutations, mapActions } from "vuex";
import Logo from "@/components/Common/Logo";
import Button from "@/components/Common/Button";
export default {
  name: "Login",
  components: {
    Logo,
    Button
  },
  data() {
    return {
      mail: "",
      error: ""
    };
  },
  computed: {
    ...mapGetters({
      getUserByMail: "getUserByMail",
      isUserExist: "isUserExist",
      getUserOnStorage: "getUserOnStorage"
    }),
    mailClean() {
      return this.mail.trim().toLowerCase();
    }
  },
  methods: {
    ...mapMutations({
      updateIsConnected: "updateIsConnected",
      updateUser: "updateUser"
    }),
    ...mapActions({
      saveUserOnStorage: "saveUserOnStorage"
    }),
    submitForm() {
      const isValid = emailValidate(this.mailClean);
      if (isValid) {
        const canPass = this.isUserExist(this.mailClean);
        if (canPass) {
          this.login();
          this.error = "";
        } else this.error = "Vous n'êtes pas inscrit à la bêta Sneakbox";
      } else {
        this.error = "Adresse email non valide";
      }
      this.mail = "";
    },
    login() {
      const user = this.getUserByMail(this.mailClean);
      this.updateUser(user);
      this.updateIsConnected(true);
      this.saveUserOnStorage();
      this.$router.push("/shoes");
    }
  },
  mounted() {
    if (this.getUserOnStorage !== null) {
      this.mail = this.getUserOnStorage;
      this.submitForm();
    }
  }
};
</script>

<style lang="scss">
.login {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  &:hover {
    background-position: bottom right;
  }
  &__popin {
    padding: 4rem 2rem;
    background: get($colors, "white");
    border-radius: get($radius, "arrounded");
    box-shadow: get($shadows, "light");
    text-align: center;
    &__logo {
      margin-bottom: 3rem;
    }
    &__subtext {
      margin-bottom: 3rem;
    }
    &__input {
      > input {
        width: 100%;
        font-size: 1.6rem;
      }

      margin-bottom: 3rem;
    }
    &__button {
      width: auto;
      margin: auto;
      font-size: 1.6rem;
    }
  }
}

.input {
  display: inline-block;
  padding: 1rem;
  border: 1px solid get($theme, "border");
  border-radius: get($radius, "arrounded");
  &:focus {
    outline-color: rgba(0, 0, 0, 0);
    border-color: get($theme, "primary");
  }
  &__error {
    margin-top: 1rem;
    color: get($colors, "red");
  }
}

.shape {
  position: fixed;
  bottom: 15vh;
  left: 50%;
  background: get($theme, "gradient-1");
  box-shadow: get($shadows, "green");
  width: 150vh;
  height: 150vh;
  z-index: -1;
  border-radius: 40%;
  transform: translate(40%, -60%);
  animation: drift 30s infinite ease-in-out;
  @media #{$md-and-up} {
    left: -20%;
    bottom: -5rem;
    width: 190rem;
    height: 200rem;
  }
}
</style>
